/**
 * Returns an array with exceptions for the sentence beginning researcher.
 * @returns {Array} The array filled with exceptions.
 */
export default [
	// Demonstrative pronouns:
	"この", "その", "あの", "こんな", "そんな", "あんな", "こう", "そう", "ああ",
];
